<template>
  <div class="main-trade">
    <div class="top-section">
      <div class="right-row">
        <div class="top-right-row">
          <selected-coin :coin = "state.marketType"/>
        </div>
        <div class="bottom-right-row">
          <trade-table/>
        </div>
      </div>

      <div class="center-row">
        <div class="top-section">
          <show-select-info-coin :data = "state.marketType" :key="state.marketType"/>
        </div>
        <div class="trading-view">
          <vue-trading-view
              :key="state.marketType"
              style="height: 292px"
              :options="{
                                autosize:false,
                                symbol :'GOLD',
                                height:'292px',
                                width:'100%',
                                timezone: 'Asia/Tehran',
                                style: '1',
                                theme: 'dark',
                                locale: 'fa_IR',
                                enable_publishing: true,
                                withdateranges: true,
                                range: 'ytd',
                                hide_side_toolbar: false,
                                allow_symbol_change: true,
                                enabled_features: [
                                    'header_fullscreen_button'
                                    ],
                                }"/>
        </div>
        <div class="buy-and-sell">
          <buy-and-sell :data = "state.marketType" :key="state.marketType"/>
        </div>
      </div>

      <div class="left-row">
        <user-panel/>
        <deep-trade/>
      </div>
    </div>
    <div class="history-table">
      <history-table/>
    </div>
  </div>
</template>

<script>
import SelectedCoin from "./components/selected-coin";
import TradeTable from "./components/trade-table";
import ShowSelectInfoCoin from "./components/show-select-info-coin";
import VueTradingView from 'vue-trading-view';
import BuyAndSell from "./components/buy-and-sell";
import DeepTrade from "./components/deep-trade";
import HistoryTable from "./components/history-table";
import UserPanel from "./components/user-panel";

export default {
  name: "main-trade",
  components: {
    UserPanel,
    HistoryTable, DeepTrade, BuyAndSell, ShowSelectInfoCoin, TradeTable, SelectedCoin, VueTradingView
  },
  //Coins fack data
  data() {
    return {
      coins: [
        {coin: 'BTC', price: 1255451, topPrice: 1451251, lowPrice: 1105565, changes: 0.6, value: 1234556},
        {coin: 'DOGE', price: 1455451, topPrice: 1545251, lowPrice: 17897565, changes: 0.8, value: 1274756},
        {coin: 'BNB', price: 17488451, topPrice: 145445251, lowPrice: 11056465, changes: 0.9, value: 15244556},
        {coin: 'ETH', price: 12452451, topPrice: 14788251, lowPrice: 74505565, changes: 0.3, value: 15457556},
        {coin: 'BCH', price: 1454451, topPrice: 5451251, lowPrice: 1454565, changes: 0.2, value: 12785756},
        {coin: 'XLM', price: 14555451, topPrice: 1455251, lowPrice: 5455565, changes: 0.1, value: 5454556},
        {coin: 'XRP', price: 4545451, topPrice: 5451251, lowPrice: 17485565, changes: 0.4, value: 14545556},
        {coin: 'TRON', price: 1545451, topPrice: 1545451, lowPrice: 1577565, changes: 0.5, value: 85774556},
      ]
    }
  },
  mounted() {
    this.$error('','درحال حاضر دسترسی به این بخش مقدور نمی باشد این بخش در حال توسعه می باشد','error','','','3500');
    setTimeout(()=>{
      this.$router.push('/');
    },3500)
  }
}


</script>

<style lang="scss" scoped>
.main-trade {
  display: flex;
  flex-direction: column;
  background-image: url("../../assets/backgrounds/trade.png");
  background-size: cover;
  background-position: center;
  direction: rtl;
  padding: 0 20px;
  margin-top: -50px;


  .top-section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    color: #FBFBFD;
    margin-top: 5px;
    align-items: flex-start;
    gap: 20px;
    height: 60%;

    .right-row {
      display: flex;
      flex-basis: 200px;
      flex-grow: 1;
      justify-content: center;
      flex-direction: column;
      width: 100%;

      .top-right-row {
        height: 50%;
      }

      .bottom-right-row {
        height: 50%;
      }

    }

    .center-row {
      flex-grow: 2;
      display: flex;
      flex-basis: 340px;
      flex-direction: column;
      gap: 15px;

      .top-section {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 10%;
      }

      .trading-view {
        height: 20%;
      }

      .buy-and-sell {
        height: 70%;
      }
    }

    .left-row {
      display: flex;
      flex-direction: column;
      height: auto;
      flex-grow: 1;
      justify-content: center;
      gap: 25px;
      margin-top: 10px;
      flex-basis: 160px;
    }
  }

  .history-table {
    height: 40%;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}

@media (max-width: 992px) {
  .left-row {
    order: 1;
  }

  .center-row {
    order: 2;
  }

  .right-row {
    order: 3;
  }
}
</style>